/**
 * A BPMN send task is represented by a message-envelope glyph. Unlike the
 * other filled task glyphs, the envelope body is a white/background surface
 * with an outline, not a solid icon.
 */
export function isBackgroundTaskIcon(
    isSendTask: boolean,
    fill: string
): boolean {
    return (
        isSendTask || fill === "white" || fill === "#ffffff" || fill === "#fff"
    );
}
